import React from 'react';
import { CheckCircle2, XCircle, CircleHelp, AlertTriangle } from 'lucide-react';

/** Visual badge for a candidate / pack verification state. */
export default function VerificationBadge({ status, size = 'sm', lastTestedAt = null, completionPct = null }) {
  const map = {
    not_tested: {
      label: 'Not tested',
      tone: 'bg-gray-100 text-gray-600 border-gray-300',
      icon: CircleHelp,
    },
    partial: {
      label: 'Tested – Partial',
      tone: 'bg-orange-50 text-orange-700 border-orange-300',
      icon: AlertTriangle,
    },
    passed: {
      label: 'Tested – Passed',
      tone: 'bg-green-50 text-green-700 border-green-300',
      icon: CheckCircle2,
    },
    failed: {
      label: 'Tested – Failed',
      tone: 'bg-red-50 text-red-700 border-red-300',
      icon: XCircle,
    },
  };
  const m = map[status] || map.not_tested;
  const Icon = m.icon;
  const sizeCls = size === 'lg'
    ? 'px-2.5 py-1 text-xs'
    : 'px-2 py-0.5 text-[10px]';
  return (
    <span
      data-testid={`verification-badge-${status || 'not_tested'}`}
      className={`inline-flex items-center gap-1 font-mono uppercase tracking-widest rounded-sm border ${m.tone} ${sizeCls}`}
      title={lastTestedAt ? `Last tested: ${relativeTime(lastTestedAt)}` : undefined}
    >
      <Icon className={size === 'lg' ? 'w-3.5 h-3.5' : 'w-3 h-3'} />
      {m.label}
      {completionPct != null && completionPct > 0 && (
        <span className="font-mono opacity-70">&nbsp;· {completionPct}%</span>
      )}
    </span>
  );
}

export function relativeTime(iso) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  const s = Math.round(diff / 1000);
  if (s < 60) return 'just now';
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hr ago`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString();
}
